import React from 'react';
import { Check } from 'react-bootstrap-icons';

import {
  CheckLabel,
  CheckBoxItem,
  CheckInput as Checkbox,
} from './CheckStyles';

type Props = {
  register: any;
  disabled?: boolean;
};

export const CheckInput: React.FC<Props> = ({
  register,
  children,
  disabled,
}) => {
  return (
    <CheckLabel>
      <Checkbox
        {...register}
        type='checkbox'
        id={register.name}
        disabled={disabled}
        readOnly={true}
      />
      <CheckBoxItem htmlFor={register.name}>
        <Check />
      </CheckBoxItem>
      {children && children}
    </CheckLabel>
  );
};
